import { SvgIcon, SvgIconProps } from '@mui/material';

const CalendarIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 6.55556H8.40015C7.56007 6.55556 7.13972 6.55556 6.81885 6.7251C6.5366 6.87424 6.3073 7.11203 6.16349 7.40473C6 7.73748 6 8.1734 6 9.0446V9.66667M9 6.55556H15M9 6.55556V5M15 6.55556H15.6001C16.4402 6.55556 16.8597 6.55556 17.1805 6.7251C17.4628 6.87424 17.6929 7.11203 17.8367 7.40473C18 7.73716 18 8.17255 18 9.04204V9.66667M15 6.55556V5M6 9.66667V16.5113C6 17.3825 6 17.8178 6.16349 18.1506C6.3073 18.4433 6.5366 18.6815 6.81885 18.8306C7.1394 19 7.55925 19 8.39768 19H15.6023C16.4408 19 16.86 19 17.1805 18.8306C17.4628 18.6815 17.6929 18.4433 17.8367 18.1506C18 17.8182 18 17.3834 18 16.5139V9.66667M6 9.66667H18M15 15.8889H15.0015L15.0015 15.8904L15 15.8904V15.8889ZM12 15.8889H12.0015L12.0015 15.8904L12 15.8904V15.8889ZM9 15.8889H9.0015L9.00146 15.8904L9 15.8904V15.8889ZM15.0015 12.7778V12.7793L15 12.7793V12.7778H15.0015ZM12 12.7778H12.0015L12.0015 12.7793L12 12.7793V12.7778ZM9 12.7778H9.0015L9.00146 12.7793L9 12.7793V12.7778Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);

export default CalendarIcon;
